import URLSearchParamsPolyfill from 'url-search-params';

if (typeof URLSearchParams === 'undefined') {
  const get = eval;
  const globalEnv = get('this');
  globalEnv.URLSearchParams = URLSearchParamsPolyfill;
}
